export type ArticleCategory = "FAQ" | "Property" | "Pricing" | "Process" | "Contact";

export interface KnowledgeArticle {
  id: string;
  title: string;
  category: ArticleCategory;
  content: string;
  keywords: string[];
  usedCount: number;
  active: boolean;
}

export const knowledgeArticles: KnowledgeArticle[] = [
  {
    id: "ka-1",
    title: "What are your payment terms?",
    category: "FAQ",
    content: "We accept 10% booking amount at the time of reservation. The remaining 90% is due at possession. We also offer flexible payment plans with construction-linked installments. Home loan assistance is available through SBI, HDFC, and Axis Bank. EMI options starting from ₹12,000 per month.",
    keywords: ["payment", "booking", "EMI", "installment", "loan"],
    usedCount: 23,
    active: true,
  },
  {
    id: "ka-2",
    title: "Is home loan available?",
    category: "FAQ",
    content: "Yes, we work with SBI, HDFC, Axis Bank, LIC Housing Finance, and ICICI Bank to provide home loans at competitive interest rates starting from 8.40% per annum. We have a dedicated loan desk to assist with documentation, eligibility checks, and processing. Pre-approved loans available for select projects.",
    keywords: ["home loan", "bank", "SBI", "HDFC", "finance", "interest rate"],
    usedCount: 18,
    active: true,
  },
  {
    id: "ka-3",
    title: "About Bandra West Project",
    category: "Property",
    content: "Our flagship project in Bandra West offers premium 2BHK and 3BHK residences. Located on Carter Road with sea-facing apartments. Amenities include swimming pool, gymnasium, clubhouse, landscaped gardens, and 24/7 security. RERA registered: P51800001234. Possession expected December 2026 for Phase 1.",
    keywords: ["Bandra", "project", "2BHK", "3BHK", "location"],
    usedCount: 15,
    active: true,
  },
  {
    id: "ka-4",
    title: "Current price list",
    category: "Pricing",
    content: "2BHK (1,100 sq.ft carpet): Starting from ₹1.8 Cr. 3BHK (1,550 sq.ft carpet): Starting from ₹2.4 Cr. 3BHK Premium Sea-facing (1,800 sq.ft carpet): Starting from ₹3.2 Cr. Prices are all-inclusive except registration and stamp duty. Price valid until 31st July 2026. GST is additional as applicable (5% for under-construction).",
    keywords: ["price", "cost", "2BHK", "3BHK", "rate", "budget"],
    usedCount: 31,
    active: true,
  },
  {
    id: "ka-5",
    title: "How does site visit work?",
    category: "Process",
    content: "Our team will schedule a site visit at your convenience, 7 days a week from 9 AM to 6 PM. A dedicated relationship manager will accompany you and walk through the sample flat, amenities, and answer all your questions. Site visits typically take 45-60 minutes. Complimentary pickup from Bandra and Khar stations available.",
    keywords: ["site visit", "schedule", "visit", "tour", "sample flat"],
    usedCount: 12,
    active: true,
  },
  {
    id: "ka-6",
    title: "What is the possession date?",
    category: "FAQ",
    content: "Phase 1 possession is scheduled for December 2026. Phase 2 possession is scheduled for June 2027. These dates are as per the RERA-registered agreement. We are currently ahead of schedule by approximately 2 months for Phase 1 construction. Grace period of 6 months is applicable as per RERA guidelines.",
    keywords: ["possession", "date", "ready", "move in", "completion", "RERA"],
    usedCount: 9,
    active: true,
  },
  {
    id: "ka-7",
    title: "Amenities available",
    category: "Property",
    content: "Our projects include: Swimming pool with separate kids' pool, fully equipped gymnasium, clubhouse with indoor games, landscaped podium gardens, children's play area, senior citizens' corner, yoga deck, jogging track, 24/7 security with CCTV, power backup for common areas, rainwater harvesting, and EV charging points. Multipurpose hall available for resident events.",
    keywords: ["amenities", "pool", "gym", "clubhouse", "security", "parking"],
    usedCount: 7,
    active: true,
  },
  {
    id: "ka-8",
    title: "Registration & stamp duty details",
    category: "Pricing",
    content: "Registration charges: 1% of the agreement value (subject to a maximum of ₹30,000 as per Maharashtra government rules for residential properties). Stamp duty: 5% of the agreement value in Maharashtra. If registered in a woman's name, stamp duty is 4%. These are government charges and not included in the property price. We handle the registration process end-to-end.",
    keywords: ["registration", "stamp duty", "government", "charges", "tax"],
    usedCount: 5,
    active: true,
  },
  {
    id: "ka-9",
    title: "Can NRIs purchase?",
    category: "FAQ",
    content: "Yes, NRIs can purchase residential property in India under FEMA regulations. No special permission is required. We assist with NRI documentation including: NRE/NRO account setup, power of attorney (if unable to be present for registration), PAN card, passport copy, and overseas address proof. Home loans for NRIs available through HDFC NRI Home Loans and SBI NRI.",
    keywords: ["NRI", "foreign", "overseas", "FEMA", "documentation"],
    usedCount: 4,
    active: true,
  },
  {
    id: "ka-10",
    title: "Documents needed for booking",
    category: "Process",
    content: "Required documents: 1) PAN card copy of all applicants/allottees, 2) Aadhaar card copy, 3) Address proof (passport/driving license/voter ID), 4) Passport size photographs (4 each), 5) Last 6 months bank statements, 6) Last 3 years IT returns (for loan), 7) Form 16 (for salaried individuals), 8) Cheque for booking amount. Our team will assist with document verification.",
    keywords: ["documents", "PAN", "Aadhaar", "booking", "papers"],
    usedCount: 8,
    active: true,
  },
  {
    id: "ka-11",
    title: "Office address & business hours",
    category: "Contact",
    content: "Our office is located at 123 Business Park, 4th Floor, Linking Road, Bandra West, Mumbai — 400050. Business hours: Monday to Saturday, 9:00 AM to 7:00 PM. Closed on Sundays and public holidays. You can reach us at +91 98765 43210 or email sales@propmaxsolutions.com. Site visits available 7 days a week by appointment.",
    keywords: ["office", "address", "hours", "contact", "location", "phone"],
    usedCount: 3,
    active: true,
  },
  {
    id: "ka-12",
    title: "Is GST applicable?",
    category: "FAQ",
    content: "Yes, 5% GST is applicable on under-construction properties as per current government norms. GST is not applicable on completed/ready-to-move-in properties that have received an Occupancy Certificate (OC). For properties booked before completion, GST is calculated on the agreement value and is separate from the property price.",
    keywords: ["GST", "tax", "under construction", "government", "charges"],
    usedCount: 6,
    active: false,
  },
];

export const suggestedArticles = [
  { id: "sug-1", question: "What is the floor plan?", askedCount: 8 },
  { id: "sug-2", question: "Do you have 1BHK options?", askedCount: 5 },
  { id: "sug-3", question: "Can I do a virtual tour?", askedCount: 4 },
];

export const kbStats = {
  totalArticles: 12,
  botAnswered: 234,
  flaggedToHuman: 89,
};

export const categoryIcons: Record<ArticleCategory, { bg: string; text: string; icon: string }> = {
  FAQ: { bg: "bg-indigo-100", text: "text-indigo-600", icon: "ri-question-answer-line" },
  Property: { bg: "bg-green-100", text: "text-green-600", icon: "ri-building-2-line" },
  Pricing: { bg: "bg-amber-100", text: "text-amber-600", icon: "ri-money-rupee-circle-line" },
  Process: { bg: "bg-blue-100", text: "text-blue-600", icon: "ri-guide-line" },
  Contact: { bg: "bg-purple-100", text: "text-purple-600", icon: "ri-phone-line" },
};

export const categoryBadgeColors: Record<ArticleCategory, string> = {
  FAQ: "bg-indigo-50 text-indigo-700",
  Property: "bg-green-50 text-green-700",
  Pricing: "bg-amber-50 text-amber-700",
  Process: "bg-blue-50 text-blue-700",
  Contact: "bg-purple-50 text-purple-700",
};